export const NAME_SPACE = 'ImageFlags';
export const ROOT_STATE_KEY = 'assetview';
export const ROOT_SLICE_KEY = 'ImageFlags';
